<template>
  <div id="group_application_outer" >

    <el-steps id="application_top_steps" :active="stepValue" finish-status="success" align-center>
      <el-step v-for="(item, index) in stepList" :key="'application_top_step' + index" :title="item"></el-step>
    </el-steps>


    <group-application-ready v-if="stepValue == 0" v-on:preview-image="showBigImage" v-on:submitSuccess="userInfoSubmitSuccess" />
    <group-application-reviewing
        v-else-if="stepValue == 1"
        v-on:nextClick="nextButtonClicked"
        v-on:errorClick="resubmitButtonClicked"
        v-on:forbidClick="forbidToHomePage"
        :status="status" />
    <group-application-paying v-else-if="stepValue == 2"
                              v-on:paySuccess="paySuccess"
                              v-on:bankSubmitSuccess="bankVoucherSubmitSuccess"
                              v-bind:status="status" />
<!--    <group-application-invoice v-else-if="stepValue==3" v-on:success="submitSuccess" />-->

  <success-vue v-else-if="stepValue == 3" v-on:gotoDetailPage="gotoVipDetailPage" />

    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
import GroupApplicationInvoice from "./groupApplicationVues/GroupApplicationInvoice";
import GroupApplicationPaying from "./groupApplicationVues/GroupApplicationPaying";
import GroupApplicationReady from "./groupApplicationVues/GroupApplicationReady";
import GroupApplicationReviewing from "./groupApplicationVues/GroupApplicationReviewing";
import GroupApplicationSuccess from "./groupApplicationVues/GroupApplicationSuccess";
import EventManager from "../../js/event-common";
export default {
  name: "GroupVipApplication",
  components: {
    GroupApplicationReviewing,
    GroupApplicationPaying,
    GroupApplicationReady,
    GroupApplicationInvoice,
    SuccessVue: GroupApplicationSuccess,
  },
  data() {
    return {
      title: '团体会员申请',
      dialogImageVisible: false,
      dialogImageUrl: null,
      showPayPage: false,
      user: null,
      status: 0,
      isUpdateUser: false,
      stepList: [
        '填写材料',
        '协会审核',
        '支付会员费'
      ],
      stepValue: 0,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    eventManager() {
      return this.$store.state.eventManager;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {

    gotoVipDetailPage() {
      this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
      this.$router.push({
        name: 'groupMemberVue'
      });
    },

    dealWithUserData() {
      let user = this.user;
      if (user == null) {
        return;
      }
      let status = user.status;
      this.status = status;
      let auditStatus = user.auditStatus;
      let stepValue = -1;
      if (status == 1 || status == 2 || status == 4 || status == 7) { // 协会审核
        stepValue = 1;
      } else if (status == 9 || status == 10 || status == 11) { // 付款页面
        stepValue = 2;
      } else if (status == 3) { // 付款成功
        stepValue = 3;
      } else {
        stepValue = 0;
      }

      if (user.auditStatus == 0) {
        stepValue = 0;
      }
      // stepValue = 1;
      // stepValue = 0;
      // stepValue = 2;
      this.stepValue = stepValue;
      if (status == 1) {
        setTimeout(this.loadData, 10 * 1000);
      }
    },

    loadData() {
      if (this.isUpdateUser) {
        return;
      }
      this.isUpdateUser = true;
      let _this = this;
      this.httpManager.ajax.ucProfile(function (data) {
        _this.isUpdateUser = false;
        let code = data.code;
        if (code == 0) {
          let user = data.data;
          _this.$store.commit('setUser', user);
          _this.user = user;
        } else {
          _this.user = _this.$store.state.user;
        }
        _this.dealWithUserData();
      }, function (data) {
        _this.isUpdateUser = false;
        _this.$toast("数据刷新失败，请刷新页面！");
        // _this.user = _this.$store.state.user;
        // _this.dealWithUserData();
      })
    },

    readyPaySubmitSuccess() {
      this.user = this.$store.state.user;
      this.status = this.user.status;
    },
    resubmitButtonClicked() {
      let user = this.$store.state.user;
      user.status = 0
      this.$store.commit('setUser', user);

      this.user = user;
      this.status = this.user.status;

    },

    paySuccess() {
      let user = this.user;
      let params = {
        id: user.id,
        status: 3
      };
      let _this = this;
      this.httpManager.ajax.postUserUpdateStatusRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.loadData();
          return;
        }
      }, function (data) {

      });
    },

    nextButtonClicked() {
      this.loadData();
    },


    resubmitButtonClicked() {
      console.log('---1');
      let user = this.$store.state.user;
      user.status = 0;
      this.$store.commit('setUser', user);
      this.user = user;
      this.stepValue = 0;
      // this.dealWithUserData();
    },
    forbidToHomePage() {
      this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
      this.$router.push({
        name: 'personalHomeVue'
      });
    },

    showBigImage(res) {
      let imageUrl = res.imageUrl;
      this.dialogImageUrl = imageUrl;
      this.dialogImageVisible = true;
    },

    userInfoSubmitSuccess() {
      this.loadData();
    },

    bankVoucherSubmitSuccess() {
      // let user = this.$store.state.user;
      // user.status = 3;
      // this.$store.commit('setUser', user);

      // this.user = user;
      // this.status = this.user.status;

      this.loadData();
    },

    submitSuccess() {
      // this.showSuccess = true;
    },
  }
}
</script>

<style scoped>

  #group_application_outer {
    margin-top: 30px;
    border: solid 1px #fc1a34;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #application_top_steps {
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    margin-bottom: 30px;
  }

  @media screen and (min-width: 768px) {
    #application_top_steps {
      width: 80%;
      /*background-color: yellow;*/
    }
  }

  #application_top_steps /deep/ .el-step__title {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 15px;

  }

  #application_top_steps /deep/ .el-step__head.is-success {
    color: #666;
    border-color: #666;
  }

  #application_top_steps /deep/ .el-step__title.is-success {
    color: #666;
    font-weight: bold;
  }

  #application_top_steps /deep/ .el-step__head.is-process {
    color: #fc1a34;
    border-color: #fc1a34;
  }

  #application_top_steps /deep/ .el-step__title.is-process {
    color: #fc1a34;
  }

  #application_top_steps /deep/ .el-step__line {
    background-color: transparent;
    border-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/components/group/GroupVipApplication.vue